module.exports = __webpack_public_path__ + "img/check-mapping.f11cbd78.svg";